export default {
  reason: "You don’t have permission to write scripts. For more information, contact your practice’s account manager.",
  close: "Close this window",
};
